import {WithdrawalTabBalanceSection} from "./balance-section";
import {PayoutHistory} from "./payout-history";
import {StyledWithdrawalTabPageWrapper} from "./styles";

export function WithdrawalTab() {
  return (
    <StyledWithdrawalTabPageWrapper>
      <WithdrawalTabBalanceSection />
      <PayoutHistory />
    </StyledWithdrawalTabPageWrapper>
  );
}
